import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  className?: string
}

const Input = (props: Props) => {
  return (
    <div
      className={twMerge([
        `
          group relative h-9 w-full rounded-md border

          
        `,
        props.className,
      ])}
    >
      <label
        className={twMerge([
          `
            pointer-events-none absolute left-5 top-1/2 z-0 -translate-y-1/2
            rounded-full bg- px-1 text-footer-text text-base
            text-opacity-60 duration-200

            group-focus-within:top-0 group-focus-within:text-xs
            group-focus-within:text-opacity-100
            group-focus-within:text-footer-text
          `,
          props.value && 'top-0 text-xs',
        ])}
      ></label>
      <input
        id={props.id ?? props.name}
        {...props}
        className={`
          z-10 h-full w-full rounded-md py-1 bg- px-4 py-
          outline-none transition duration-200  border-[#D4D8E3]
        `}
      />
    </div>
  )
}

export default Input
